import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const ShopAD = () => (
  <div>Shop AD</div>
);

export default withStyles(styles)(ShopAD);

